export var RepositoryAssetType;
(function (RepositoryAssetType) {
    RepositoryAssetType["REPOSITORY_ASSET_TYPE_DBT_PROJECT"] = "DBT_PROJECT";
})(RepositoryAssetType || (RepositoryAssetType = {}));
